export enum TipoRegistro {
    INTERVALO_TEMPO = 'Intervalo de tempo',
    HORARIO_ESPECIFICO = 'Horário específico'
}
